import { read, write } from './_base';
import { Billing_Contacts_Url, Billing_Contact_Url, Billing_Contact_Phone_Url } from '../../api/api.endpoints';
import {
  Contact,
  ContactListResponse,
  ContactType,
  CreateContactPayload,
  UpdateContactPayload,
} from '../../schema/billing/contact';

export const listContacts = (params?: { type?: ContactType; q?: string }) =>
  read<ContactListResponse>(Billing_Contacts_Url, 'Failed to load customers', params).then(
    (r) => r.contacts ?? [],
  );

export const getContact = (id: string) =>
  read<Contact>(Billing_Contact_Url(id), 'Failed to load customer');

// `silent` suppresses the success toast for callers that show their own
// confirmation (e.g. the editor's Add-customer SuccessDialog). The error toast
// always fires. Other callers (Customers screen) get the toast by default.
export const createContact = (body: CreateContactPayload, opts?: { silent?: boolean }) =>
  write<Contact>('post', Billing_Contacts_Url, {
    body,
    errorTitle: 'Could not create customer',
    ...(opts?.silent ? {} : { successTitle: 'Customer created', successFallback: 'Saved to CRM.' }),
  });

export const updateContact = (id: string, body: UpdateContactPayload) =>
  write<Contact>('patch', Billing_Contact_Url(id), {
    body,
    errorTitle: 'Could not update customer',
    successTitle: 'Customer updated',
  });

/** Soft-delete a customer (CRM sets deleted_at; recoverable). Success is shown
 *  via a dialog by the caller, so no success toast here. */
export const deleteContact = (id: string) =>
  write<{ deleted: boolean; id: string }>('delete', Billing_Contact_Url(id), { errorTitle: 'Could not delete customer' });

/** Change a customer's phone via CRM's audited admin route. `phone` must be
 *  E.164 (e.g. +919884012345); `reason` is required and logged by the CRM. */
export const changeContactPhone = (id: string, phone: string, reason: string) =>
  write<Contact>('post', Billing_Contact_Phone_Url(id), { body: { phone, reason }, errorTitle: 'Could not change phone' });
